import React, { useMemo } from "react";
import { useDictionary } from "hooks";
import Helper, { HUMAN_ETHICS_STUDIES_API } from "./helpers";

import IntegrationComponent from "components/flowable/Integration/IntegrationComponent";

const HumanEthicsStudySearch = props => {
	const { config, onEvent, onChange } = props;

	const dictionary = useDictionary("humanEthicsSearch");

	const humanEthicsDictionary = useMemo(() => {
		return {
			headline: dictionary?.headline || "Link to Human Ethic Studies",
			description: dictionary?.description
		}
	}, [ dictionary ]);

	const cardKeys = useMemo(() => {
		return {
			studyNumber: dictionary.study ?? "Study",
			title: dictionary.title ?? "Title",
			approvalDate: dictionary.approvalDate ?? "Approval Date",
			expirationDate: dictionary.expirationDate ?? "Expiration Date",
			principleInvestigator: dictionary.principleInvestigator ?? "PI",
			status: dictionary.status ?? "Status"
		}
	}, [ dictionary ]);

	return (
		<IntegrationComponent
			helper={Helper}
			url={HUMAN_ETHICS_STUDIES_API}
			cardKeys={cardKeys}
			dictionary={humanEthicsDictionary}
			config={config}
			onChange={onChange}
			onEvent={onEvent}
		/>
	);
};

export default HumanEthicsStudySearch;
